export default "__VITE_ASSET__kyGlwmJ$__"